import React, { useState, useEffect } from "react";
import AccountInfo from "./AccountInfo";
import MarginTool from "./MarginTool";
import Config from "./Config";
import { useFont } from "../../contexts/FontContext/FontContext";
import { Link } from "react-router-dom";
import styles from "./SettingsView.module.css";
import UtilityButton from "../UtilityButton/UtilityButton";

const SettingsView = ({ settingsOptionSelected, setSettingsOptionSelected }) => {
	const [hoveredSettingsOption, setHoveredSettingsOption] = useState(null);
	const [fadeClassAccountInfo, setFadeClassAccountInfo] = useState("no_opacity");
	const [fadeClassConfig, setFadeClassConfig] = useState("no_opacity");
	const [fadeClassMargins, setFadeClassMargins] = useState("no_opacity");
	const [fadeClassPasswordReset, setFadeClassPasswordReset] = useState("no_opacity");
	const [settingsButtonsEnabled, setSettingsButtonsEnabled] = useState(false);
	const [settingsOptionBlurbOpacity, setSettingsOptionBlurbOpacity] = useState({
		account_info: "no_opacity",
		config: "no_opacity",
		margins: "no_opacity",
		password_reset: "no_opacity"
	});
	const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 

    const fadeInSettingsOptions = () => {  
		setFadeClassAccountInfo("no_opacity");
		setFadeClassConfig("no_opacity");
		setSettingsButtonsEnabled(false);
		resetSettingsOptionBlurbOpacity();
		if (settingsOptionSelected === "settings_back") {
			setFadeClassAccountInfo("fade_in"); 
			setFadeClassConfig("fade_in");
			setFadeClassMargins("fade_in");
			setFadeClassPasswordReset("fade_in");
		} else {
			setFadeClassAccountInfo("fade_in_bounce"); 
			setTimeout(() => { setFadeClassConfig("fade_in_bounce"); }, 300);
			setTimeout(() => { setFadeClassMargins("fade_in_bounce"); }, 600);
			setTimeout(() => { setFadeClassPasswordReset("fade_in_bounce"); }, 900);
		}
		setSettingsButtonsEnabled(true);
	};

	useEffect(() => {
		if (settingsOptionSelected === null || settingsOptionSelected === "settings_back") { fadeInSettingsOptions(); }
	}, [settingsOptionSelected]);

	const highlightSettingsOption = (option) => { 
		setHoveredSettingsOption(option);
		setSettingsOptionBlurbOpacity({
			account_info: option === "account_info" ? "fade_in" : "no_opacity",
			config: option === "config" ? "fade_in" : "no_opacity",
			margins: option === "margins" ? "fade_in" : "no_opacity",
			password_reset: option === "password_reset" ? "fade_in" : "no_opacity"
		});
	};

	// Reset all blurbs to "no_opacity" when the mouse leaves
	const resetSettingsOptionBlurbOpacity = () => {
		setHoveredSettingsOption(null);
		setSettingsOptionBlurbOpacity({
			account_info: "no_opacity",
			config: "no_opacity",
			margins: "no_opacity",
			password_reset: "no_opacity"
		});
	};

	const selectSettingsOption = (option) => { setSettingsOptionSelected(option); };

	const highlightSettingsOptionBorder = (option) => {
		return hoveredSettingsOption === option ? { boxShadow: "0 4px 20px 0 rgba(0, 0, 0, .5), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" } : { boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.3), 0 3px 10px 0 rgba(0, 0, 0, 0.1)" };
	};

	//toggle back and forth between gif and png
	const getImageSrc = (option, defaultSrc, hoverSrc) => { 
		return hoveredSettingsOption === option ? hoverSrc : defaultSrc; 
	};

	const renderSelectedComponent = () => {
		switch (settingsOptionSelected) {
	    	case "account_info":
	      		return <AccountInfo settingsOptionSelected={settingsOptionSelected} setSettingsOptionSelected={setSettingsOptionSelected} font={fontFamilyOne} />;
	      	case "margins":
	      		return <MarginTool settingsOptionSelected={settingsOptionSelected} setSettingsOptionSelected={setSettingsOptionSelected} font={fontFamilyOne} />;
	      	case "config":
	      		return <Config settingsOptionSelected={settingsOptionSelected} setSettingsOptionSelected={setSettingsOptionSelected} font={fontFamilyOne} />;
	    	default:
	      		return (
			        <>
						<UtilityButton id={styles.settings_blurbs} imageId={styles.account_images} title="Account info" option="account_info" imageSrc={getImageSrc("account_info", `${process.env.PUBLIC_URL}/images/account_info.png`, `${process.env.PUBLIC_URL}/images/account_info.gif`)} onHover={highlightSettingsOption} onLeave={resetSettingsOptionBlurbOpacity} onClick={selectSettingsOption} fadeClass={fadeClassAccountInfo} isSelected={null} isDisabled={!settingsButtonsEnabled} borderStyle={highlightSettingsOptionBorder("account_info")}/>
						{/*<UtilityButton id={styles.settings_blurbs} imageId={styles.account_images} title="Billing" option="billing" imageSrc={getImageSrc("billing", `${process.env.PUBLIC_URL}/images/billing.png`, `${process.env.PUBLIC_URL}/images/billing.gif`)} onHover={highlightSettingsOption} onLeave={resetSettingsOptionBlurbOpacity} onClick={selectSettingsOption} fadeClass={fadeClassConfig} isSelected={null} isDisabled={!settingsButtonsEnabled} borderStyle={highlightSettingsOptionBorder("billing")}/>*/}
						<UtilityButton id={styles.settings_blurbs} imageId={styles.account_images} title="Config" option="config" imageSrc={getImageSrc("config", `${process.env.PUBLIC_URL}/images/config.png`, `${process.env.PUBLIC_URL}/images/config.gif`)} onHover={highlightSettingsOption} onLeave={resetSettingsOptionBlurbOpacity} onClick={selectSettingsOption} fadeClass={fadeClassConfig} isSelected={null} isDisabled={!settingsButtonsEnabled} borderStyle={highlightSettingsOptionBorder("config")}/>
						<UtilityButton id={styles.settings_blurbs} imageId={styles.account_images} title="Margins" option="margins" imageSrc={getImageSrc("margins", `${process.env.PUBLIC_URL}/images/margins.png`, `${process.env.PUBLIC_URL}/images/margins.gif`)} onHover={highlightSettingsOption} onLeave={resetSettingsOptionBlurbOpacity} onClick={selectSettingsOption} fadeClass={fadeClassMargins} isSelected={null} isDisabled={!settingsButtonsEnabled} borderStyle={highlightSettingsOptionBorder("margins")}/>
						<Link to="/forgot_password" state={{ fromSettings: true }} style={{ all: "unset", display: "contents" }}><UtilityButton id={styles.settings_blurbs} imageId={styles.account_images} title="Password Reset" option="password_reset" imageSrc={getImageSrc("password_reset", `${process.env.PUBLIC_URL}/images/password_reset.png`, `${process.env.PUBLIC_URL}/images/password_reset.gif`)} onHover={highlightSettingsOption} onLeave={resetSettingsOptionBlurbOpacity} onClick={selectSettingsOption} fadeClass={fadeClassPasswordReset} isSelected={null} isDisabled={!settingsButtonsEnabled} borderStyle={highlightSettingsOptionBorder("password_reset")}/></Link>
					</>
		    	);
	  	}
	};
	// Link styling is to remove default styling provided by Link tags
	return (
		<div className={styles.settings_container}>
			{renderSelectedComponent()}
		</div>
	);
};

export default SettingsView;